import { useQuery } from '@/helpers/useQuery';

import Page from '@/components/layout/Page';
import BackButton from '@/components/common/BackButton';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import PageLoading from '@/components/layout/PageLoading';

import EditCoachForm from './components/editCoachPage/EditCoachForm';

import { useCoachSelf } from '@/data/coach';
import { useCoachActivities } from '@/data/coachActivity';
import { useApplication } from '@/data/application';

const EditCoachPage = () => {
  const coach = useCoachSelf();
  const coachActivities = useCoachActivities();
  const coachActivityId = useQuery('coachActivityId');
  const applicationStructure = useApplication({ coachActivityId });

  if (coach.isLoading && !coach.data) {
    return <PageLoading />;
  }
  if (coachActivities.isLoading && !coachActivities.data) {
    return <PageLoading />;
  }
  if (applicationStructure.isLoading && !applicationStructure.data) {
    return <PageLoading />;
  }

  const backLink = coachActivityId
    ? `/application/${coachActivityId}`
    : '/application/add';

  return (
    <Page>
      <BackButton to={backLink} />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Personal Information</CardTitle>
        </CardHeader>
        <CardContent>
          <EditCoachForm coach={coach.data} />
        </CardContent>
      </Card>
    </Page>
  );
};

export default EditCoachPage;
